<template>
  <van-popup
      v-model="showPopup"
      round
      position="bottom"
      closeable
      close-icon-position="top-right"
      :close-on-click-overlay="false"
      @close="cancel"
  >
    <div class="modal-container">
      <div class="modal-title">结算账户设置</div>
      <van-form @submit="onSubmit">
        <van-field
            v-model.trim="form.bankName"
            name="bankName"
            label="开户银行"
            placeholder="请选择开户银行"
            :rules="[{ required: true, message: '请选择开户银行' }]"
            readonly
            @click="showDeviceTypePicker = true"
        >
          <template #right-icon>
            <van-icon name="arrow-down" />
          </template>
        </van-field>
        <van-popup
            v-model="showDeviceTypePicker"
            round
            position="bottom"
        >
          <van-picker
              show-toolbar
              title="选择开户银行"
              :columns="deviceTypeOptions"
              values="text"
              @confirm="onDeviceTypeConfirm"
              @cancel="showDeviceTypePicker = false"
          />
        </van-popup>
        <van-field
            v-model.trim="bankBranch"
            name="bankBranch"
            label="开户支行"
            placeholder="请输入开户支行"
            :rules="[{ required: true, message: '请输入开户支行' }]"
        />
        <van-field
            v-model.trim="form.agentName"
            name="agentName"
            label="开户名"
            placeholder="请输入开户名"
            :disabled="true"
            :rules="[{ required: true, message: '请输入开户名' }]"
        />
        <van-field
            v-model.trim="bankCardNumber"
            name="bankCardNumber"
            label="银行卡号"
            placeholder="请输入银行卡号"
            :rules="[{ required: true, message: '请输入银行卡号' }]"
        />
        <div class="bank-tip">
          温馨提示：请确保填写的银行账户信息准确无误，该账户将用于福彩销售佣金结算。
        </div>
        <div class="form-buttons">
          <van-button round block plain type="default" native-type="button" @click="cancel">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" native-type="submit">保存</van-button>
        </div>
      </van-form>
    </div>
  </van-popup>
</template>
<script>
import {blurRule, CheckBankNo} from '@/untils/common';
export default {
  name: 'addBankInfo',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    update:{
      type:Boolean,
      default:false
    },
    agentInfo:{
      type:Object,
      default: {}
    }
  },
  data() {
    return {
      showPopup: this.value,
      showDeviceTypePicker: false,
      disabled:true,
      bankName:this.agentInfo.bankName,
      bankBranch:this.agentInfo.bankBranch,
      bankCardNumber:this.agentInfo.bankCardNumber,
      form: {},
      deviceTypeOptions: [
        {id:1,text:'中国建设银行'},
      ],
    }
  },
  watch: {
    value(val) {
      this.showPopup = val;
    },
    showPopup(val) {
      this.$emit('input', val);
    },
    agentInfo: {
      immediate: true, // 立即执行一次
      handler(newVal) {
        if (newVal) {
          // 在这里处理数据
          this.form = newVal;
          this.bankBranch = newVal.bankBranch;
          this.bankCardNumber = newVal.bankCardNumber;
        }
      }
    }
  },
  created() {
  },
  methods: {
    onDeviceTypeConfirm(value) {
      this.form.bankName = value.text;
      this.showDeviceTypePicker = false;
    },
    onSubmit() {
      if(this.bankBranch===''){
        this.$toast('开户支行不能为空');
        return false;
      }else if (!blurRule(this.bankBranch, {name: 'bankName'})) {
        return false;
      }
      if(this.bankCardNumber===''){
        this.$toast('银行卡号不能为空');
        return false;
      }
      if(!CheckBankNo(this.bankCardNumber)){
        return false;
      }
      // 开户支行
      this.form.bankBranch = this.bankBranch;
      this.form.bankCardNumber = this.bankCardNumber;
      this.$emit('submit', { ...this.form });
    },
    cancel() {
      this.showPopup = false;
      this.form = this.agentInfo;
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
